export default __webpack_public_path__ + "21ac420acac82f127156a453a36292f0.svg";